import Actions from './actions';
import { UNRECOVERABLE, TOAST, REDIRECT, FORM } from './models';

const initialState = [];

const errors = (state = initialState, action) => {
  switch (action.type) {
    case Actions.ADD: {
      return [
        {
          message:
            action.error && action.error.message ? action.error.message : '',
          type: TOAST,
          open: action.open,
        },
        ...state,
      ];
    }

    case Actions.FORM: {
      // if there is an existing error in the form with same form id and form
      // error message, replace it with the latest error
      const errors = state.filter(el => {
        return el.formId !== action.formId || el.error !== action.error;
      });
      return [
        ...errors,
        {
          ...action,
          type: FORM,
        },
      ];
    }

    case Actions.REDIRECT: {
      return [
        {
          routeId: action.routeId,
          type: REDIRECT,
        },
        ...state,
      ];
    }
    case Actions.UNRECOVERABLE: {
      return [
        {
          error: action.error,
          type: UNRECOVERABLE,
        },
        ...state,
      ];
    }
    case Actions.DISMISS:
      return state.filter(err => err !== action.payload);
    default:
      return state;
  }
};

export default errors;
